module.exports = __webpack_public_path__ + "static/media/huella-loading.b3fea7ae.gif";